const areas = {
  timberWallsRoom: {
    width: "",
    length: "",
    height: "",
    windows: "0",
  },
  timberWall: {
    width: "",
    height: "",
    windows: "0",
  },
  timberDoor: {
    width: "",
    height: "",
  },
  benchTop: {
    width: "",
    length: "",
  },
  smallTable: {},
  largeTable: {},
  diningTable: {},
  miscFurniture: {
    width: "",
    length: "",
    height: "",
  },
  concreteFloor: {
    width: "",
    length: "",
  },
  floorHouse: {
    width: "",
    length: "",
  },
  floorRoom: {
    width: "",
    length: "",
  },
  deck: {
    width: "",
    length: "",
  },
  cladding: {
    width: "",
    length: "",
    height: "",
    doors: "0",
    windows: "0",
  },
  windows: {
    windows: "0",
  },
  outdoorFurniture: {
    width: "",
    length: "",
    height: "",
  },
};

let sequence = 0;

export default (type) => {
  sequence += 1;

  return {
    ...areas[type],
    id: sequence,
    type,
  };
};
